import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { MediaPlanType } from 'src/app/data/vo/MediaPlanOptionVO';
import { environment } from '../../../../environments/environment';
import {
    AttributesData,
    AttributesInput,
    AudienceExpressionsData,
    AudienceSizeData,
    AudienceSizeInput,
    BaseParams,
    CampaignAttributeConstraint,
    CampaignAttributeCriteria,
    CampaignBudgetData,
    CampaignBudgetUpdateInput,
    CampaignCreationData,
    CampaignCreationInput,
    CampaignDashboardData,
    CampaignDashboardInput,
    CampaignDashboardRow,
    CampaignFlightCreationInput,
    CampaignFlightData,
    CampaignGoalConstraint,
    CampaignGoalConstraintInput,
    CampaignMediaPlanData,
    CampaignNameUpdateInput,
    CampaignObjectiveCreationInput,
    CampaignObjectiveData,
    CampaignObjectiveUpdateInput,
    CampaignPricingSummary,
    CampaignSegmentData,
    CampaignSegmentInput,
    CampaignStatusUpdateInput,
    DemoOptionsParams,
    MediaPlanOptionData,
    MediaPlanOptionsInput,
    MediaPlanStatusInput,
    MediaPlanStatusResponse,
    PlanCreationData,
    PlanCreationInput,
    PrebuiltCampaignData,
    SegmentData,
    CampaignIdParam,
    CampaignSettingsData,
    TotalAudienceCriteria, AvailsData, PacingReportData, CampaignPricingSummaryBody, CampaignOrder
} from './campaign-data';

const endpoints = {
    campaignDashboard: '/rows',
    plans: '/v1/converged/platformClients/{platform_client_id}/plans',
    plan: '/v1/converged/plans/{plan_id}',
    campaigns: '/v1/converged/plans/{plan_id}/campaigns',
    campaign: '/v1/converged/campaigns/{campaign_id}',
    flights: '/v1/converged/campaigns/{campaign_id}/flights',
    flightsUpdate: '/v1/converged/flights/{flight_id}',
    segments: '/v1/converged/audiences',
    campaignSegment: '/v1/converged/campaigns/{campaign_id}/audience',
    //used for attributes and demo
    attributes: '/v1/converged/attributes',
    buyDemo: '/v1/converged/campaigns/{campaign_id}/buy-demo',
    campaignBudget: '/v1/converged/campaigns/{campaign_id}/pricing',
    campaignObjectives: '/v1/converged/campaigns/{campaign_id}/goal/objectives',
    campaignExistObjectives: '/v1/converged/campaigns/{campaign_id}/goal/objectives/{campaign_objective_id}',
    campaignConstraints: '/v2/converged/campaigns/{campaign_id}/constraints',
    campaignConstraint: '/v2/converged/campaigns/{campaign_id}/constraints/{constraint_id}',
    campaignGoalConstraints: '/v1/converged/campaigns/{campaign_id}/goal/constraints',
    campaignGoalConstraint: '/v1/converged/campaigns/{campaign_id}/goal/constraints/{constraint_id}',
    prebuiltCampaignData: '/v1/converged/campaigns/{campaign_id}/templates',
    campaignStatus: '/v1/converged/campaigns/{campaign_id}/status',
    campaignPayment: '/v1/converged/orders/{orderId}',
    campaignMediaPlan: '/v2/converged/campaigns/{campaignId}/mediaplans',
    campaignOrder: '/v1/converged/orders',
    totalAudience: '/v1/converged/campaigns/{campaign_id}/totalAudience',
    audienceExpressions: '/v2/converged/expressions/{audienceId}',
    audienceSize: '/v1/converged/audienceUniverseEstimate',
    mediaPlanOptions: '/v1/converged/{campaignId}/mediaplanoptions',
    campaignPricingSummary: '/v1/converged/campaigns/{campaignId}/pricingSummary',
    mediaPlanStatus: '/v1/converged/campaigns/{campaignId}/mediaplans/{mediaplanId}/status',
    avails: '/v1/converged/broadcast-calendar/avails',
    mediaPlanDownload: '/v1/converged/campaigns/{campaignId}/mediaplans/{mediaplanId}',
    campaignSettings: '/v1/converged/campaigns/{campaign_id}/settings',
    pacingReportData: '/v1/converged/reporting/campaigns/{campaign_id}/pacing-metrics',
    pacingReportDataDownload: '/v1/converged/tv-pacing-report?campaign_id={campaign_id}&type=POST',
};

export const api = {
    getCampaignDashboard: getCampaignDashboard,
    createPlan: createPlan,
    getPlan: getPlan,
    createCampaign: createCampaign,
    updateCampaignName: updateCampaignName,
    deleteCampaign: deleteCampaign,
    getCampaignData: getCampaignData,
    getPrebuiltCampaignData: getPreBuiltCampaignData,
    createCampaignFlight: createCampaignFlight,
    updateCampaignFlight: updateCampaignFlight,
    getCampaignFlight: getCampaignFlight,
    getSegments: getSegments,
    updateCampaignSegment: updateCampaignSegment,
    getCampaignSegment: getCampaignSegment,
    deleteCampaignSegment: deleteCampaignSegment,
    getAttributes: getAttributes,
    getDemoOptions: getDemoOptions,
    saveCampaignDemo: saveCampaignDemo,
    getCampaignDemo: getCampaignDemo,
    saveCampaignAttributes: saveCampaignAttributes,
    getCampaignAttributes: getCampaignAttributes,
    updateCampaignAttributes: updateCampaignAttributes,
    deleteCampaignAttributes: deleteCampaignAttributes,
    updateCampaignBudget: updateCampaignBudget,
    getCampaignBudget: getCampaignBudget,
    getCampaignObjectives: getCampaignObjectives,
    createCampaignObjective: createCampaignObjective,
    updateCampaignObjective: updateCampaignObjective,
    deleteCampaignObjective: deleteCampaignObjective,
    submitCampaign: submitCampaign,
    getOrder: getOrder,
    getCampaignMediaPlan: getCampaignMediaPlan,
    getTotalAudienceCriteria: getTotalAudienceCriteria,
    getAudienceExpressions: getAudienceExpressions,
    getAudienceSize: getAudienceSize,
    updateAdDurationConstraints: updateAdDurationConstraints,
    getMediaPlanOptions: getMediaPlanOptions,
    createCampaignGoalConstraint: createCampaignGoalConstraint,
    updateCampaignGoalConstraint: updateCampaignGoalConstraint,
    getCampaignGoalConstraints: getCampaignGoalConstraints,
    getCampaignPricingSummary: getCampaignPricingSummary,
    getMediaPlanStatus: getMediaPlanStatus,
    updateMediaPlanStatus: updateMediaPlanStatus,
    getAvails: getAvails,
    downloadMediaPlan: downloadMediaPlan,
    getMediaPlanData: getMediaPlanData,
    getPacingReportData: getPacingReportData,
    downloadPacingReportData: downloadPacingReportData,
    getCampaignSettings: getCampaignSettings,
    updateCampaignSettings: updateCampaignSettings,
    getCampaignsCount: getCampaignsCount,
    getCampaignOrder: getCampaignOrder,
};

function getCampaignDashboard(http: HttpClient, input: CampaignDashboardInput): Promise<CampaignDashboardData> {
    const endpoint: string = environment.campaignDashboardUrl + endpoints.campaignDashboard;
    const requestHeaders: HttpHeaders = new HttpHeaders(
        {
            'x-included-fields': 'campaign_id,campaign_name,campaign_status,budget,start_date,end_date,currency_abbreviation,additional_discount',
            'Content-Type': 'application/json'
        }
    );

    return http.post(endpoint, input, {
        headers: requestHeaders,
        observe: 'response'
    }).toPromise().then((response: HttpResponse<CampaignDashboardRow[]>) => {
        const result = new CampaignDashboardData();
        result.count = +response.headers.get('X-Resource-Total');
        result.data = response.body;
        return result;
    });

}

function createPlan(http: HttpClient, input: PlanCreationInput): Promise<PlanCreationData> {
    const endpoint = environment.campaignUrl + endpoints.plans.replace('{platform_client_id}', input.platform_client_id.toString());
    return http.post(endpoint, input).toPromise().then((response: PlanCreationData) => {
        return response;
    });
}

function createCampaign(http: HttpClient, input: CampaignCreationInput): Promise<CampaignCreationData> {
    const endpoint = environment.campaignUrl + endpoints.campaigns.replace('{plan_id}', input.plan_id.toString());
    return http.post(endpoint, input).toPromise().then((response: CampaignCreationData) => {
        return response;
    });
}

function updateCampaignName(http: HttpClient, input: CampaignNameUpdateInput): Promise<CampaignCreationData> {
    const endpoint = environment.campaignUrl + endpoints.campaign.replace('{campaign_id}', input.campaign_id.toString());
    return http.put(endpoint, input).toPromise().then((response: CampaignCreationData) => {
        return response;
    });
}

function deleteCampaign(http: HttpClient, campaign_id: number): Promise<any> {
    const endpoint = environment.campaignUrl + endpoints.campaign.replace('{campaign_id}', campaign_id.toString());
    return http.delete(endpoint).toPromise().then((response: any) => {
        return response;
    });
}

function getCampaignData(http: HttpClient, campaign_id: number): Promise<CampaignCreationData> {
    const endpoint = environment.campaignUrl + endpoints.campaign.replace('{campaign_id}', campaign_id.toString());
    return http.get(endpoint).toPromise().then((response: CampaignCreationData) => {
        return response;
    });
}

function getPreBuiltCampaignData(http: HttpClient, campaign_id: number): Promise<Array<PrebuiltCampaignData>> {
    const endpoint = environment.campaignUrl + endpoints.prebuiltCampaignData.replace('{campaign_id}', campaign_id.toString());
    return http.get(endpoint).toPromise().then((response: PrebuiltCampaignData[]) => {
        return response;
    });
}

function createCampaignFlight(http: HttpClient, input: CampaignFlightCreationInput): Promise<any> {
    const endpoint = environment.campaignUrl + endpoints.flights.replace('{campaign_id}', input.campaign_id.toString());
    return http.post(endpoint, input).toPromise().then((response) => {
        return response;
    });
}

function getCampaignFlight(http: HttpClient, campaign_id: number): Promise<CampaignFlightData> {
    const endpoint = environment.campaignUrl + endpoints.flights.replace('{campaign_id}', campaign_id.toString());
    return http.get(endpoint).toPromise().then((flights: Array<CampaignFlightData>) => {
        return (flights && flights.length > 0) ? flights[0] : null;
    });
}

function updateCampaignFlight(http: HttpClient, input: CampaignFlightData) {
    const endpoint = environment.campaignUrl + endpoints.flightsUpdate.replace('{flight_id}', input.flight_id.toString());
    return http.put(endpoint, input).toPromise().then((flight: CampaignFlightData) => {
        return flight;
    });
}

function getSegments(http: HttpClient, params: CampaignIdParam): Promise<SegmentData[]> {
    const requestHeaders: HttpHeaders = new HttpHeaders(
        {
            'x-embedded-modules': 'bt_segments_count, strategic_demo, data_providers',
            'Content-Type': 'application/json'
        }
    );
    return http.get(environment.campaignUrl + endpoints.segments,
        { params: params.toHttpParams(), headers: requestHeaders }).toPromise().then((resp: SegmentData[]) => {
            return resp;
        });
}

function updateCampaignSegment(http: HttpClient, input: CampaignSegmentInput): Promise<CampaignSegmentData> {
    return http.put(environment.campaignUrl + endpoints.campaignSegment.replace('{campaign_id}', input.campaign_id.toString()), input)
        .toPromise().then((resp: CampaignSegmentData) => {
            return resp;
        });
}

function getCampaignSegment(http: HttpClient, input: CampaignSegmentInput): Promise<CampaignSegmentData> {
    return http.get(environment.campaignUrl + endpoints.campaignSegment.replace('{campaign_id}', input.campaign_id.toString()))
        .toPromise().then((resp: CampaignSegmentData) => {
            return resp;
        });
}

function deleteCampaignSegment(http: HttpClient, campaign_id: number): Promise<any> {
    return http.delete(environment.campaignUrl + endpoints.campaignSegment.replace('{campaign_id}', campaign_id.toString()))
        .toPromise().then();
}

function getAttributes(http: HttpClient, input: AttributesInput, params: BaseParams): Promise<AttributesData[]> {
    return http.post(environment.campaignUrl + endpoints.attributes, input, { params: params.toHttpParams() })
        .toPromise().then((resp: AttributesData[]) => {
            return resp;
        });
}

function getDemoOptions(http: HttpClient): Promise<AttributesData[]> {
    let params = new DemoOptionsParams();
    return http.get(environment.campaignUrl + endpoints.attributes, { params: params.toHttpParams() }).toPromise().then((resp: AttributesData[]) => {
        return resp;
    });
}

function saveCampaignDemo(http: HttpClient, input: CampaignAttributeCriteria, campaignId: number): Promise<CampaignAttributeCriteria> {
    return http.put(environment.campaignUrl + endpoints.buyDemo.replace('{campaign_id}', campaignId.toString()), input)
        .toPromise().then((resp: CampaignAttributeCriteria) => {
            return resp;
        });
}

function getCampaignDemo(http: HttpClient, campaignId: number): Promise<CampaignAttributeCriteria> {
    return http.get(environment.campaignUrl + endpoints.buyDemo.replace('{campaign_id}', campaignId.toString()))
        .toPromise().then((resp: CampaignAttributeCriteria) => {
            return resp;
        });
}

function updateCampaignBudget(http: HttpClient, input: CampaignBudgetUpdateInput): Promise<CampaignBudgetData> {
    const endpoint = environment.campaignUrl + endpoints.campaignBudget.replace('{campaign_id}', input.campaign_id.toString());
    return http.put(endpoint, input).toPromise().then((response: CampaignBudgetData) => {
        return response;
    });
}

function getCampaignBudget(http: HttpClient, campaign_id: number): Promise<CampaignBudgetData> {
    const endpoint = environment.campaignUrl + endpoints.campaignBudget.replace('{campaign_id}', campaign_id.toString());
    return http.get(endpoint).toPromise().then((resp: CampaignBudgetData) => {
        return resp;
    });
}

function getCampaignObjectives(http: HttpClient, campaign_id: number): Promise<CampaignObjectiveData[]> {
    const endpoint = environment.campaignUrl + endpoints.campaignObjectives.replace('{campaign_id}', campaign_id.toString());
    return http.get(endpoint).toPromise().then((resp: CampaignObjectiveData[]) => {
        return resp;
    });
}

function createCampaignObjective(http: HttpClient, input: CampaignObjectiveCreationInput): Promise<CampaignObjectiveData> {
    const endpoint = environment.campaignUrl + endpoints.campaignObjectives.replace('{campaign_id}', input.campaign_id.toString());
    return http.post(endpoint, input).toPromise().then((response: CampaignObjectiveData) => {
        return response;
    });
}

function updateCampaignObjective(http: HttpClient, input: CampaignObjectiveUpdateInput): Promise<CampaignObjectiveData[]> {
    const endpoint = environment.campaignUrl + endpoints.campaignExistObjectives.replace('{campaign_id}', input.campaign_id.toString())
        .replace('{campaign_objective_id}', input.campaign_objective_id.toString());
    return http.put(endpoint, input).toPromise().then((response: CampaignObjectiveData[]) => {
        return response;
    });
}

function deleteCampaignObjective(http: HttpClient, campaignId: number, campaignObjectiveId: number): Promise<any> {
    const endpoint = environment.campaignUrl + endpoints.campaignExistObjectives.replace('{campaign_id}', campaignId.toString())
        .replace('{campaign_objective_id}', campaignObjectiveId.toString());
    return http.delete(endpoint).toPromise();
}

function saveCampaignAttributes(http: HttpClient, input: CampaignAttributeConstraint, campaignId: number): Promise<CampaignAttributeConstraint> {
    return http.post(environment.campaignUrl + endpoints.campaignConstraints.replace('{campaign_id}', campaignId.toString()), input)
        .toPromise().then((resp: CampaignAttributeConstraint) => {
            return resp;
        });
}

function getCampaignAttributes(http: HttpClient, campaignId: number): Promise<CampaignAttributeConstraint[]> {
    return http.get(environment.campaignUrl + endpoints.campaignConstraints.replace('{campaign_id}', campaignId.toString()))
        .toPromise().then((resp: CampaignAttributeConstraint[]) => {
            return resp;
        });
}

function updateCampaignAttributes(http: HttpClient, input: CampaignAttributeConstraint, campaignId: number): Promise<CampaignAttributeConstraint> {
    return http.put(environment.campaignUrl +
        endpoints.campaignConstraint.replace('{campaign_id}', campaignId.toString())
            .replace('{constraint_id}', input.constraint_id), input)
        .toPromise().then((resp: CampaignAttributeConstraint) => {
            return resp;
        });
}

function deleteCampaignAttributes(http: HttpClient, campaignId: number, constraintId: String): Promise<any> {
    const endpoint = environment.campaignUrl + endpoints.campaignConstraint.replace('{campaign_id}', campaignId.toString())
        .replace('{constraint_id}', constraintId.toString());
    return http.delete(endpoint).toPromise();
}

function submitCampaign(http: HttpClient, campaignId: number, input: CampaignStatusUpdateInput): Promise<any> {
    const endpoint = environment.campaignUrl + endpoints.campaignStatus.replace('{campaign_id}', campaignId.toString());
    return http.put(endpoint, input).toPromise();
}

function getOrder(http: HttpClient, orderId: string): Promise<CampaignOrder> {
    let endpoint = environment.campaignUrl + endpoints.campaignPayment.replace('{orderId}', orderId);

    return http.get(endpoint).toPromise().then(
        (response: CampaignOrder) => {
            return response;
        }
    );
}

function getCampaignMediaPlan(http: HttpClient, campaignId: number): Promise<Array<CampaignMediaPlanData>> {
    let endpoint = environment.campaignUrl + endpoints.campaignMediaPlan.replace('{campaignId}', campaignId.toString());
    return http.get(endpoint).toPromise().then(
        (response: Array<CampaignMediaPlanData>) => {
            return response;
        }
    );
}


function getTotalAudienceCriteria(http: HttpClient, campaign_id: number): Promise<TotalAudienceCriteria> {
    const endpoint = environment.campaignUrl + endpoints.totalAudience.replace('{campaign_id}', campaign_id.toString());
    return http.get(endpoint).toPromise().then((resp: TotalAudienceCriteria) => {
        return resp;
    });
}

function getAudienceSize(http: HttpClient, input: AudienceSizeInput): Promise<AudienceSizeData> {
    return http.post(environment.campaignUrl + endpoints.audienceSize, input)
        .toPromise().then((resp: AudienceSizeData) => {
            return resp;
        });
}

function getAudienceExpressions(http: HttpClient, expressionId: string): Promise<AudienceExpressionsData> {
    const endpoint = environment.campaignUrl + endpoints.audienceExpressions.replace('{audienceId}', expressionId);
    const requestHeaders: HttpHeaders = new HttpHeaders(
        {
            'x-embedded-modules': 'expression_value',
            'Content-Type': 'application/json'
        }
    );
    return http.get(endpoint, { headers: requestHeaders }).toPromise().then((resp: AudienceExpressionsData) => {
        return resp;
    });
}

/**
 * Update or Remove ad duration constraints
 *
 * @param input if this is empty, it will remove all ad duration constraints
 */
function updateAdDurationConstraints(http: HttpClient, campaignId: number, input: CampaignAttributeConstraint[]): Promise<Array<CampaignAttributeConstraint>> {
    let endpoint = environment.campaignUrl + endpoints.campaignConstraints.replace('{campaign_id}', campaignId.toString());
    return http.put(endpoint, input).toPromise().then((resp: Array<CampaignAttributeConstraint>) => {
        return resp;
    });
}

function getMediaPlanOptions(http: HttpClient, campaignId: number, input: MediaPlanOptionsInput): Promise<MediaPlanOptionData[]> {
    const endpoint = environment.campaignUrl + endpoints.mediaPlanOptions.replace('{campaignId}', campaignId.toString());
    return http.post(endpoint, input).toPromise().then(resp => {
        return resp['media_plan_options'];
    });
}

function createCampaignGoalConstraint(http: HttpClient, campaignId: number, input: CampaignGoalConstraintInput) {
    const endpoint = environment.campaignUrl + endpoints.campaignGoalConstraints.replace('{campaign_id}', campaignId.toString());
    return http.post(endpoint, input).toPromise().then((resp: CampaignGoalConstraint) => {
        return resp;
    });
}

function getCampaignGoalConstraints(http: HttpClient, campaignId: number) {
    const endpoint = environment.campaignUrl + endpoints.campaignGoalConstraints.replace('{campaign_id}', campaignId.toString());
    return http.get(endpoint).toPromise().then((resp: CampaignGoalConstraint[]) => {
        return resp;
    });
}

function updateCampaignGoalConstraint(http: HttpClient, campaignId: number, input: CampaignGoalConstraint) {
    const endpoint = environment.campaignUrl + endpoints.campaignGoalConstraint.replace('{campaign_id}', campaignId.toString())
        .replace('{constraint_id}', input.id.toString());
    return http.put(endpoint, input).toPromise().then((resp: CampaignGoalConstraint) => {
        return resp;
    });
}

function getCampaignPricingSummary(http: HttpClient, campaignId: number, creativeIds?: number[], discountCode?: string, mediaPlanType?: MediaPlanType) {
    let params = mediaPlanType ? { selectedMediaPlanOption: mediaPlanType } : undefined;
    let body: CampaignPricingSummaryBody = {
        currency_id: environment.currencyId,
        discount_code: discountCode,
        entities: [
            {
                entity_id: campaignId,
                entity_type: 'CAMPAIGN'
            }
        ]
    };
    if (creativeIds && creativeIds.length > 0) {
        creativeIds.forEach((creativeId) => {
            body.entities.push({ entity_id: creativeId, entity_type: 'MEDIA' });
        })
    }
    const endpoint = environment.campaignUrl + endpoints.campaignPricingSummary.replace('{campaignId}', campaignId.toString());
    return http.post(endpoint, body, { params: params }).toPromise().then((resp: CampaignPricingSummary) => {
        return resp;
    });
}

function getMediaPlanStatus(http: HttpClient, campaignId: number, mediaplanId: number): Promise<MediaPlanStatusResponse> {
    const endpoint = environment.campaignUrl + endpoints.mediaPlanStatus.replace('{campaignId}', campaignId.toString())
        .replace('{mediaplanId}', mediaplanId.toString());
    return http.get(endpoint).toPromise().then((resp: MediaPlanStatusResponse) => {
        return resp;
    });
}

function updateMediaPlanStatus(http: HttpClient, input: MediaPlanStatusInput, campaignId: number, mediaplanId: number): Promise<MediaPlanStatusResponse> {
    return http.put(environment.campaignUrl +
        endpoints.mediaPlanStatus.replace('{campaignId}', campaignId.toString())
            .replace('{mediaplanId}', mediaplanId.toString()), input)
        .toPromise().then((resp: MediaPlanStatusResponse) => {
            return resp;
        });
}

function getAvails(http: HttpClient, campaignId: number): Promise<AvailsData[]> {
    let params = new HttpParams().set('campaignId', campaignId.toString());
    return http.get(environment.campaignUrl + endpoints.avails, { params: params }).toPromise().then((resp: AvailsData[]) => {
        return resp;
    });
}

function getMediaPlanData(http: HttpClient, campaignId: number, mediaplanId: number): Promise<CampaignMediaPlanData> {
    const endpoint = environment.campaignUrl + endpoints.mediaPlanDownload.replace('{campaignId}', campaignId.toString())
        .replace('{mediaplanId}', mediaplanId.toString());
    return http.get(endpoint).toPromise().then((resp: CampaignMediaPlanData) => {
        return resp;
    });
}

function downloadMediaPlan(http: HttpClient, campaignId: number, mediaplanId: number): Promise<Blob> {
    const endpoint = environment.campaignUrl + endpoints.mediaPlanDownload.replace('{campaignId}', campaignId.toString())
        .replace('{mediaplanId}', mediaplanId.toString());
    const requestHeaders: HttpHeaders = new HttpHeaders(
        {
            'Accept': 'application/file'
        }
    );
    return http.get(endpoint, {
        headers: requestHeaders,
        responseType: 'blob'
    }).toPromise().then((resp) => {
        return resp;
    });
}

function getPacingReportData(http: HttpClient, campaignId: number): Promise<PacingReportData> {
    const endpoint = environment.campaignUrl + endpoints.pacingReportData.replace('{campaign_id}', campaignId.toString());
    return http.get(endpoint).toPromise().then((resp: PacingReportData) => {
        return resp;
    });
}

function downloadPacingReportData(http: HttpClient, campaignId: number): Promise<Blob> {
    const endpoint = environment.campaignUrl + endpoints.pacingReportDataDownload.replace('{campaign_id}', campaignId.toString());
    const requestHeaders: HttpHeaders = new HttpHeaders(
        {
            'Accept': 'application/file'
        }
    );
    return http.get(endpoint, {
        headers: requestHeaders,
        responseType: 'blob'
    }).toPromise().then((resp) => {
        return resp;
    });
}

function getCampaignSettings(http: HttpClient, campaignId: number): Promise<CampaignSettingsData> {
    const endpoint = environment.campaignUrl + endpoints.campaignSettings.replace('{campaign_id}', campaignId.toString());
    return http.get(endpoint).toPromise().then((resp: CampaignSettingsData) => {
        return resp;
    });
}

function updateCampaignSettings(http: HttpClient, input: CampaignSettingsData, campaignId: number): Promise<CampaignSettingsData> {
    return http.put(environment.campaignUrl + endpoints.campaignSettings.replace('{campaign_id}', campaignId.toString()), input)
        .toPromise().then((resp: CampaignSettingsData) => {
            return resp;
        });
}

function getCampaignsCount(http: HttpClient, input: CampaignDashboardInput): Promise<number> {
    const endpoint: string = environment.campaignDashboardUrl + endpoints.campaignDashboard;
    const requestHeaders: HttpHeaders = new HttpHeaders(
        {
            'x-included-fields': 'campaign_id',
            'Content-Type': 'application/json'
        }
    );

    return http.post(endpoint, input, {
        headers: requestHeaders,
        observe: 'response'
    }).toPromise().then((response: HttpResponse<CampaignDashboardRow[]>) => {
        return +response.headers.get('X-Resource-Total');
    });
}

function getPlan(http: HttpClient, plan_id: number): Promise<PlanCreationData> {
    const endpoint = environment.campaignUrl + endpoints.plan.replace('{plan_id}', plan_id.toString());
    return http.get(endpoint).toPromise().then((response: PlanCreationData) => {
        return response;
    });
}

function getCampaignOrder(http: HttpClient, campaignId: number): Promise<Array<CampaignOrder>> {
    const endpoint = environment.campaignUrl + endpoints.campaignOrder;
    let params = {
        entity_id: campaignId.toString(),
        entity_type: 'CAMPAIGN'
    };
    return http.get(endpoint, { params: params }).toPromise().then((response: Array<CampaignOrder>) => {
        return response;
    });
}
